import { inferAdditionalFields } from 'better-auth/client/plugins'
import { twoFactorClient } from 'better-auth/plugins/two-factor'
import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
    // Point this directly to your Express server's base URL.
    // Better Auth will append "/api/auth" to this automatically.
    baseURL: import.meta.env.VITE_BASE_API_ORIGIN,
    // fetchOptions: {
    //     credentials: 'include' // Required for sending/receiving cookies cross-origin
    // },
    // Optional: Add plugins if you are using them on your backend (e.g., passkeys, organization)
    plugins: [
        twoFactorClient(),
        // This automatically types your fields across signUp, useSession, etc.
        inferAdditionalFields({
            user: {
                firstName: {
                    type: 'string',
                    required: true
                },
                lastName: {
                    type: 'string',
                    required: true
                }
            }
        })
    ]
})

// Auth client calls made with `throw: true` reject with a BetterFetchError, whose `error` is the response body
export const getAuthError = (err: unknown): { code?: string; message?: string } | undefined =>
    (err as { error?: { code?: string; message?: string } } | null)?.error
